import './breakoutblock.less'

import {Icon} from '@codeurs/front'
import {BreakoutModel} from 'models/program/BreakoutModel'
import {BreakoutroomModel} from 'models/program/BreakoutroomModel'
import {SequenceModel} from 'models/program/SequenceModel'
import {SessionModel} from 'models/program/SessionModel'
import React, {useRef, useState} from 'react'
import {DOMAttrs} from 'types'
import {style} from 'util/style'
import {
	Programblock,
	ProgramblockContent,
	ProgramblockTime
} from 'views/program/blocks/programblock'
import {Sequenceblock} from 'views/program/blocks/sequenceblock'
import {Sessionblock} from 'views/program/blocks/sessionblock'

const styles = style('breakoutblock', ['room'])

export const Breakoutblock: React.FC<{
	breakout: BreakoutModel
}> = ({breakout}) => {
	if (!breakout.rooms) return null

	const [activeRoom, setRoom] = useState(breakout.rooms[0])
	const {title, start_time, end_time} = breakout
	const breakoutRef = useRef<HTMLDivElement>(null)

	const handleScroll = () => {
		window.scrollTo({
			top: breakoutRef.current.getBoundingClientRect().top + window.scrollY,
			left: 0,
			behavior: 'smooth'
		})
	}

	return (
		<div className={styles()}>
			<Programblock mod="breakout">
				<ProgramblockTime start_time={start_time} end_time={end_time} />
				<ProgramblockContent title={title} />
			</Programblock>
			<div className={styles('rooms')}>
				{breakout.rooms.map(room => (
					<BreakoutblockRoom
						room={room}
						active={room === activeRoom}
						onClick={() => {
							setRoom(room)
							handleScroll()
						}}
					/>
				))}
			</div>
			<div className={styles('content')} ref={breakoutRef}>
				{activeRoom?.schedule.map(item => {
					if (item instanceof SessionModel)
						return <Sessionblock session={item} mod="breakout" />
					if (item instanceof SequenceModel)
						return <Sequenceblock sequence={item} mod="breakout" />
				})}
			</div>
		</div>
	)
}

export const BreakoutblockRoom: React.FC<{
	room: BreakoutroomModel
	active: boolean
} & DOMAttrs> = ({room, active, ...rest}) => {
	const {title, description} = room

	return (
		<div className={styles.room().is({active})} {...rest}>
			<div className={styles.room('content')}>
				<div className={styles.room('content-title')}>{title}</div>
				<div className={styles.room('content-subtitle')}>{description}</div>
			</div>
			<div className={styles.room('arrow')}>
				<Icon icon="chevron-down-wide" />
			</div>
		</div>
	)
}
